// Owner 22/10/2026 (every store, desktop + phones): when a Buy 1 / 2 / 3 offer is picked, scroll so the "Buy More, Unlock More
// FREE Gifts" pill sits at the top of the screen and the Add to cart button at the bottom. When both cannot fit, Add to cart wins
// (fully in view) and the pill slides above the top edge. Only a real click / tap on an offer card counts; size or gift pickers
// inside a card do not. Same file on every store; only CFG differs (written by tools/offer-scroll/deploy.mjs).
(() => {
  if (window.__offerScroll) return;
  window.__offerScroll = true;
  const CFG = /*CFG*/{"cards":".st-bundle__tier","pill":".st-bundle__head--pill","atc":"button[name=\"add\"]","skip":""}/*CFG*/;
  const GAP = 12;
  const shown = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const fixed = (el) => { for (let p = el; p && p !== document.body; p = p.parentElement) if (getComputedStyle(p).position === 'fixed') return true; return false; };
  const follows = (a, b) => !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING); // b comes after a
  const scroller = (el) => {
    for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
      const o = getComputedStyle(p).overflowY;
      if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
    }
    return window;
  };
  // a full-width sticky / fixed header covering the top of the screen
  const headerBottom = () => {
    let b = 0;
    for (const el of document.elementsFromPoint(innerWidth / 2, 1)) {
      for (let p = el; p && p !== document.body; p = p.parentElement) {
        const pos = getComputedStyle(p).position;
        if (pos !== 'fixed' && pos !== 'sticky') continue;
        const r = p.getBoundingClientRect();
        if (r.top <= 1 && r.width > innerWidth * 0.6 && r.height < innerHeight / 3) b = Math.max(b, r.bottom);
        break;
      }
    }
    return b;
  };

  function reveal(card) {
    if (!shown(card)) return;
    let pill = null, atc = null;
    for (let box = card.parentElement; box && !(pill && atc); box = box.parentElement) {
      pill = pill || [...box.querySelectorAll(CFG.pill)].filter((x) => shown(x) && follows(x, card)).pop();
      atc = atc || [...box.querySelectorAll(CFG.atc)].find((x) => shown(x) && follows(card, x) && !fixed(x));
      if (box === document.body) break;
    }
    if (!atc) return;
    const vh = window.innerHeight;
    const top = (pill || card.parentElement).getBoundingClientRect().top;
    let d = top - headerBottom() - GAP;
    const a = atc.getBoundingClientRect().bottom;
    if (a - d > vh - GAP) d = a - (vh - GAP); // too tall for the screen: Add to cart fully in view
    if (Math.abs(d) < 4) return;
    scroller(card).scrollBy({ top: d, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  let timer = 0;
  document.addEventListener('click', (e) => {
    if (!e.isTrusted || !CFG.cards) return;
    const card = e.target.closest && e.target.closest(CFG.cards);
    if (!card || (CFG.skip && e.target.closest(CFG.skip))) return;
    const inner = e.target.closest('select, a, button, input:not([type="radio"]), textarea, summary');
    if (inner && inner !== card && card.contains(inner)) return;
    clearTimeout(timer); // a label click fires twice (label + its radio)
    timer = setTimeout(() => reveal(card), 200);
  });
})();
